<template>
  <div class="payInfo">
    <div class="qrcode">
      <QRcode
        v-if="qrcode.code_url"
        :QRlink="qrcode.code_url"
        :qrwidth="210"
        :qrheight="210"
      />
    </div>

    <div class="payRight">
      <div>
        <div class="scanTip" style="">
          <i class="ico_wechat"></i>请使用<span class="wechatText">微信</span
          >扫码支付
        </div>
        <div class="yfText">应付金额：</div>
        <div><span class="money">￥69</span>/年</div>
      </div>
      <div>
        <div class="qrtimeValid">
          二维码有效时长：<span class="qrTimer">{{ timerText }}</span>
        </div>
        <div class="refreshTip">
          如无法支付或者二维码已过期请点击<span class="refresh"> 刷新</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRcode from "./QRcode.vue";
export default {
  components: { QRcode },
  data() {
    return {
      qrcode: {
        code_url: ""
      },
      timerText: "09:59",
      timer: 600
    };
  },

  created() {
    this.qrcode.code_url = "http://www.baidu.com";

    var min = this.timer / 60;
    min = min - 1;
    let qrTimer = setInterval(() => {
      this.timer--;
      let second = this.timer % 60;
      if (second === 0) {
        if (min === 0) {
          this.timerText = "已失效";
          clearInterval(qrTimer);
          return;
        } else {
          min = min - 1;
        }
      }
      this.timerText = "0" + min + ":" + (second < 10 ? "0" + second : second);
    }, 1000);
  }
};
</script>

<style lang="scss" scoped>
.payInfo {
  display: flex;
  color: #6e6e6e;
  .payRight {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    line-height: 26px;
    .scanTip {
      display: flex;
      align-items: center;
      margin-right: 12px;
      font-size: 16px;
      margin-bottom: 20px;
      .ico_wechat {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/ico_wechat.png") no-repeat;
        background-size: cover;
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 12px;
      }
    }
    .yfText {
      font-size: 18px;
      margin-bottom: 15px;
    }
    .money {
      font-size: 32px;
      color: #ff5129;
    }
    .qrtimeValid {
      margin-bottom: 10px;
      .qrTimer {
        color: #ff5129;
      }
    }
    .refreshTip {
      .refresh {
        color: #47a2ff;
        cursor: pointer;
      }
    }
  }
  .qrcode {
    width: 210px;
    height: 210px;
    //   background: #000;
    margin-right: 37px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payInfo.vue